import { Checkbox, Input, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import type { ChannelKey } from '../types';

export type ChannelConfigSectionProps = {
    channel: ChannelKey;
    enabled: boolean;
    versionName: string;
    downloadUrl: string;
    disabled?: boolean;
    onEnabledChange: (enabled: boolean) => void;
    onVersionChange: (value: string) => void;
    onUrlChange: (value: string) => void;
};

const ChannelConfigSection: React.FC<ChannelConfigSectionProps> = ({
    channel,
    enabled,
    versionName,
    downloadUrl,
    disabled,
    onEnabledChange,
    onVersionChange,
    onUrlChange,
}) => {
    return (
        <div className={`channel-tile ${enabled ? 'is-active' : ''}`}>
            <Checkbox checked={enabled} disabled={disabled} onChange={(event) => onEnabledChange(event.target.checked)}>
                <FormattedMessage id={`appVersionUpdates.channel.${channel}.label`} />
            </Checkbox>
            <div className={`channel-tile__fields ${enabled ? '' : 'is-disabled'}`}>
                <div className="field-block">
                    <Typography.Text className="field-block__label">
                        <FormattedMessage id="appVersionUpdates.form.versionThreshold" />
                    </Typography.Text>
                    <Input
                        size="large"
                        value={versionName}
                        disabled={disabled || !enabled}
                        placeholder="1.2.5"
                        onChange={(event) => onVersionChange(event.target.value)}
                    />
                </div>
                <div className="field-block">
                    <Typography.Text className="field-block__label">
                        <FormattedMessage id="appVersionUpdates.form.downloadUrl" />
                    </Typography.Text>
                    <Input
                        size="large"
                        value={downloadUrl}
                        disabled={disabled || !enabled}
                        placeholder={channel === 'apk' ? 'https://example.com/app.apk' : 'https://...'}
                        onChange={(event) => onUrlChange(event.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default ChannelConfigSection;
